import React, { useEffect, useState } from "react";
import Logo_Black from "../../assets/Logo_black.png";
import { scroller } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";

const GET_STARTED_URL = "https://app.thespherex.com/";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (sectionId) => {
    setIsOpen(false);
    if (location.pathname !== "/") {
      navigate(`/?scrollTo=${sectionId}`);
    } else {
      scroller.scrollTo(sectionId, {
        smooth: true,
        duration: 500,
        offset: -80,
      });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled
          ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-100 py-3.5"
          : "bg-white/80 backdrop-blur-sm py-4"
        }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between">
        {/* Brand Logo */}
        <div
          onClick={() => handleNavClick("home")}
          className="cursor-pointer flex items-center gap-2"
        >
          <img src={Logo_Black} alt="SphereX" className="h-8 sm:h-9 w-auto object-contain" />
        </div>

        {/* Desktop Navigation Links */}
        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-gray-600">
          <button
            onClick={() => handleNavClick("services")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            Services
          </button>
          <button
            onClick={() => handleNavClick("how-it-works")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            How It Works
          </button>
          <button
            onClick={() => handleNavClick("why-us")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            Why SphereX
          </button>
          <button
            onClick={() => handleNavClick("testimonials")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            Reviews
          </button>
          <button
            onClick={() => handleNavClick("faq")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            FAQ
          </button>
          <button
            onClick={() => handleNavClick("support")}
            className="hover:text-purple-600 transition-colors focus:outline-none"
          >
            Support
          </button>
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href={GET_STARTED_URL}
            className="text-sm font-semibold text-gray-700 hover:text-purple-600 px-3 py-2 rounded-lg transition-colors"
          >
            Sign In
          </a>
          <a
            href={GET_STARTED_URL}
            className="inline-flex items-center gap-1.5 bg-purple-600 hover:bg-purple-700 text-white text-sm font-bold px-5 py-2.5 rounded-full shadow-sm hover:shadow-md transition-all duration-200 transform hover:-translate-y-0.5"
          >
            <span>Get Started</span>
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>

        {/* Mobile Hamburger Button */}
        <button
          className="md:hidden text-gray-700 p-2 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle navigation menu"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile Drawer */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-gray-100 shadow-xl px-5 pt-3 pb-6 animate-fadeIn">
          <nav className="flex flex-col gap-3 font-semibold text-gray-700 text-base">
            <button
              onClick={() => handleNavClick("services")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => handleNavClick("how-it-works")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              How It Works
            </button>
            <button
              onClick={() => handleNavClick("why-us")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              Why SphereX
            </button>
            <button
              onClick={() => handleNavClick("testimonials")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              Reviews
            </button>
            <button
              onClick={() => handleNavClick("faq")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              FAQ
            </button>
            <button
              onClick={() => handleNavClick("support")}
              className="text-left py-2 border-b border-gray-50 hover:text-purple-600 transition-colors"
            >
              Support & Contact
            </button>

            <div className="pt-3 flex flex-col gap-2.5">
              <a
                href={GET_STARTED_URL}
                className="w-full text-center py-2.5 font-semibold text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-xl transition-colors text-sm"
              >
                Sign In
              </a>
              <a
                href={GET_STARTED_URL}
                className="w-full flex items-center justify-center gap-2 py-3 font-bold text-white bg-purple-600 hover:bg-purple-700 rounded-xl shadow-md transition-colors text-sm"
              >
                <span>Get Started</span>
                <ArrowUpRight className="w-4 h-4" />
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
